import styled from 'styled-components';
import { rgba } from 'polished';
import media from '../../styles/config/mediaQueries';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';

const StyledContainer = styled.div`
  ${StyledWrapper} {
    padding: 0;
  }
  ${media.mobile`
    padding-top: 20px;
  `}
  ${media.desktop`
    width: 100%;
    max-width: 332px;
  `}
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.mobile`
    margin-bottom: 22px;
  `}
  ${media.desktop`
    margin-bottom: 29px;
  `}
`;

const StyledHeading = styled.div`
  ${media.desktop`
    display: flex;
    align-items: center;
  `}
`;

const StyledContentWrapper = styled.div`
  ${media.desktop`
    max-width: 332px;
  `}
`;

const StyledTitle = styled.h2`
  width: 100%;
  margin-right: 10px;
  ${media.mobile`
    ${typeStyle['font-18-bold']}
  `}
  ${media.desktop`
    ${typeStyle.h1}
  `}
`;

const StyledSaveButton = styled.button`
  svg {
    width: 26px;
    height: 26px;
  }

  ${media.desktop`
    line-height: 0.5;
  `}
`;

const StyledBackButton = styled.button`
  position: relative;
  align-self: center;
  margin-right: 12px;
  width: 16px;
  min-width: 16px;
  height: 16px;
  transform: rotate(180deg);
  background-color: ${theme.color.white};
  border-radius: 2px;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    transform: translate(-50%, -50%);

    path {
      fill: ${theme.color.black};
    }
  }
`;

const StyledDescription = styled.p`
  color: ${rgba(theme.color.white, 0.7)};
  ${typeStyle['font-14']};
  ${media.mobile`
    margin-bottom: 31px;
  `}
  ${media.desktop`
    margin-bottom: 18px;
  `}
`;

export {
  StyledContainer,
  StyledHeader,
  StyledHeading,
  StyledContentWrapper,
  StyledTitle,
  StyledSaveButton,
  StyledBackButton,
  StyledDescription,
};
